import React from 'react'
import { Outlet } from 'react-router-dom';

import Header from "./Header";
import Sidebar from "./Sidebar";
import { useSelector } from 'react-redux'

function Layout() {
	const layoutSelector = useSelector(state => state.layout)

	return (
		<div id="layout-wrapper">
			<Header />
			<Sidebar />
			<div className={"main-content " + (layoutSelector.showleftMenu ? 'sidebar-active-margin' : 'sidebar-margin')}>
				<div className="page-content">
					<Outlet />
				</div>
			</div>
		</div>
	)
}

export default Layout